import React from 'react';
import styled from 'styled-components';
import Spinner from '../Spinner/index';

const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 20px;
  flex-shrink: 0;
`;

const HistoryLoadingSpinner = () => (
  <SpinnerWrapper>
    <Spinner size={20} />
  </SpinnerWrapper>
);

export default HistoryLoadingSpinner;



// WEBPACK FOOTER //
// ./src/components/MessageHistory/HistoryLoadingSpinner.js